import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UserGetSingleProductDetails } from '../../../redux/user/product/user_product_services_syn';
import { useParams } from 'react-router-dom';
import LoaderScreen from '../../../component/loader/loaderScreen';
import CurrencyFormatter from '../../../component/CurrencyFormatter';
import {
  UserCartCreation,
  UserGetSingleCart,
} from '../../../redux/user/cart/cartServicesSync';
import { InfinitySpin, TailSpin } from 'react-loader-spinner';
import { calculateDiscount } from '../../../utils/calculateDiscountPercentage';
import {
  UserGetSingleWishList,
  UserWishListCreation,
} from '../../../redux/user/wish_list/wish_list_services_sync';
import { PhotoView } from 'react-photo-view';

const User_DeviceProduct = () => {
  const { productId } = useParams();

  const dispatch = useDispatch();

  const [colorIndicator, setColorIndicator] = useState('');

  const { productDetails, product_loader } = useSelector(
    (state) => state.user_product
  );

  const { cartDetails, cart_loader } = useSelector((state) => state.user_cart);

  const { wishListDetails, wish_list_loader } = useSelector(
    (state) => state.user_wish_list
  );

  console.log(wishListDetails, 'wishListDetails');

  useEffect(() => {
    dispatch(UserGetSingleCart({ Id: productId }));
    dispatch(UserGetSingleWishList({ Id: productId }));
    dispatch(UserGetSingleProductDetails({ Id: productId }));
  }, [productId]);

  const addToCart = (productId, quantity) => {
    dispatch(UserCartCreation({ productId, quantity, color: colorIndicator }));
  };

  const addToWishlist = (productId, quantity) => {
    dispatch(
      UserWishListCreation({ productId, quantity, color: colorIndicator })
    );
  };

  return (
    <>
      {product_loader && <LoaderScreen />}

      {!product_loader && (
        <div class="row">
          <div class="col-lg-4">
            <div class="card">
              <div class="card-body">
                <div
                  id="carouselExampleFade"
                  class="carousel slide carousel-fade"
                  data-bs-ride="carousel"
                >
                  <div class="carousel-inner" role="listbox">
                    {productDetails?.gallery?.map((item, key) => (
                      <div key={key} class="carousel-item active">
                        <PhotoView
                          src={
                            item?.pic_url || '/assets/images/product/p-1.png'
                          }
                        >
                          <img
                            src={item?.pic_url}
                            alt=""
                            class="img-fluid bg-light rounded"
                          />
                        </PhotoView>
                      </div>
                    ))}
                  </div>
                  <div class="carousel-indicators m-0 mt-2 d-lg-flex d-none position-static h-100">
                    {productDetails?.gallery?.map((item, key) => (
                      <button
                        type="button"
                        data-bs-target="#carouselExampleFade"
                        data-bs-slide-to={key}
                        aria-current="true"
                        aria-label={`Slide ${key + 1}`}
                        class="w-auto h-auto rounded bg-light active"
                      >
                        <img
                          src={item?.pic_url}
                          class="d-block avatar-xl"
                          alt="swiper-indicator-img"
                        />
                      </button>
                    ))}
                  </div>
                </div>
              </div>
              <div class="card-footer border-top">
                <div class="row g-2">
                  <div
                    class="col-lg-5"
                    onClick={() =>
                      !cart_loader && addToCart(productDetails?._id, 1)
                    }
                  >
                    <a class="btn btn-primary d-flex align-items-center justify-content-center gap-2 w-100">
                      {cart_loader ? (
                        <InfinitySpin width="50" color="#FFFFFF" />
                      ) : (
                        <>
                          <i class="bx bx-cart fs-18"></i> Add To Cart
                        </>
                      )}
                    </a>
                  </div>
                  <div class="col-lg-5">
                    <a
                      href="#!"
                      class="btn btn-light d-flex align-items-center justify-content-center gap-2 w-100"
                    >
                      <i class="bx bx-shopping-bag fs-18"></i> View Cart
                    </a>
                  </div>
                  <div class="col-lg-2">
                    <button
                      type="button"
                      class="btn btn-soft-danger d-inline-flex align-items-center justify-content-center fs-20 rounded w-100"
                      onClick={() =>
                        !wish_list_loader &&
                        addToWishlist(productDetails?._id, 1)
                      }
                    >
                      {wish_list_loader ? (
                        <div>
                          <TailSpin width="20" height={'20'} color="#FFFFFF" />
                        </div>
                      ) : (
                        <>
                          {wishListDetails?.product ? (
                            <iconify-icon icon="solar:heart-bold"></iconify-icon>
                          ) : (
                            <iconify-icon icon="solar:heart-broken"></iconify-icon>
                          )}
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="card">
              <div class="card-body">
                <h4 class="badge bg-success text-light fs-14 py-1 px-2">
                  {/* New Arrival */}
                </h4>
                <p class="mb-1">
                  <a href="#!" class="fs-24 text-dark fw-medium">
                    {productDetails?.product_name}
                  </a>
                </p>

                <h2 class="fw-medium my-3">
                  {Number(productDetails?.discount) <
                  Number(productDetails?.price) ? (
                    <CurrencyFormatter
                      value={productDetails?.discount}
                      currency={productDetails?.symbol}
                    />
                  ) : (
                    <CurrencyFormatter
                      value={productDetails?.price}
                      currency={productDetails?.symbol}
                    />
                  )}{' '}
                  {Number(productDetails?.discount) <
                    Number(productDetails?.price) && (
                    <>
                      <span class="fs-16 text-decoration-line-through">
                        <CurrencyFormatter
                          value={productDetails?.price}
                          currency={productDetails?.symbol}
                        />
                      </span>
                      <small class="text-danger ms-2">
                        (
                        <>
                          {calculateDiscount(
                            Number(productDetails?.price),
                            Number(productDetails?.discount)
                          )}
                        </>
                        %Off)
                      </small>
                    </>
                  )}
                </h2>

                {productDetails?.colors?.length > 0 && (
                  <div class="row align-items-center g-2 mt-3">
                    <div class="col-lg-3">
                      <div class="flex flex-col gap-2">
                        <h5 class="text-dark fw-medium">{`Colors > `}</h5>
                        <div
                          class="d-flex flex-wrap gap-2"
                          role="group"
                          aria-label="Basic checkbox toggle button group"
                        >
                          {productDetails?.colors?.map((color, index) => (
                            <div
                              key={index}
                              style={{ backgroundColor: color }}
                              className={`w-10 h-10 rounded-full border cursor-pointer ${
                                color === colorIndicator ? `outline` : ``
                              }`}
                              onClick={() => setColorIndicator(color)}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div class="quantity mt-4">
                  <h4 class="text-dark fw-medium mt-3">Quantity :</h4>
                  {cart_loader ? (
                    <InfinitySpin width="80" color="#FE6B30" />
                  ) : (
                    <div class="input-step border bg-body-secondary p-1 mt-1 rounded d-inline-flex overflow-visible flex items-center">
                      <button
                        type="button"
                        class="minus bg-light text-dark border-0 rounded-1 fs-20 lh-1 h-100 p-1"
                        onClick={() => {
                          if (cartDetails?.quantity > 1) {
                            addToCart(productDetails?._id, -1);
                          }
                        }}
                      >
                        -
                      </button>
                      <input
                        type="number"
                        class="text-dark text-center border-0 bg-body-secondary rounded h-100 "
                        value={cartDetails?.quantity || 0}
                        min="0"
                        max="100"
                        readonly=""
                      />
                      <button
                        type="button"
                        class="plus bg-light text-dark border-0 rounded-1 fs-20 lh-1 h-100 p-1"
                        onClick={() => {
                          if (cartDetails?.quantity > 0) {
                            addToCart(productDetails?._id, 1);
                          }
                        }}
                      >
                        +
                      </button>
                    </div>
                  )}
                </div>
                <ul class="d-flex flex-column gap-2 list-unstyled fs-15 my-3">
                  <li>
                    <i class="bx bx-check text-success"></i> In Stock
                  </li>
                  <li>
                    <i class="bx bx-check text-success"></i> Free delivery
                    available
                  </li>
                  {/* <li>
                      <i class="bx bx-check text-success"></i> Sales 10% Off Use
                      Code: <span class="text-dark fw-medium">CODE123</span>
                    </li> */}
                </ul>
                <h4 class="text-dark fw-medium">Description :</h4>
                <p class="text-muted">
                  {productDetails?.description}.{' '}
                  <a href="#!" class="link-primary">
                    Read more
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default User_DeviceProduct;
